import React from 'react';
import IdleTimer from 'react-idle-timer';
import { observer } from 'mobx-react';
import { Redirect, Route } from 'react-router-dom';
import { Switch } from 'react-router';
import PublicArea from './containers/PublicArea/PublicArea';
import PrivateArea from './containers/PrivateArea/PrivateArea';
import store from './stores/store';
import ModalPopup from './containers/_shared/ModalPopup';
import { TIMEOUT } from './helpers/constants';
import { TIMEOUT_HEADER_MSG, TIMEOUT_CONTENT_MSG } from './helpers/messageText';
//import NotFoundPage from './containers/PublicArea/components/404Page';

// import DevTools from 'mobx-react-devtools';

const App = observer(
    class App extends React.Component {
        componentWillMount() {
            if (window.offlineApiExtension) {
                store.conn.pollOnlineStatus();
            }
        }

        componentWillUnmount() {
            if (window.offlineApiExtension) {
                store.conn.stopPolling();
            }
        }

        onActive = () => {
            //console.log('IdleTimer onactive')
        };

        onIdle = () => {
            store.alert.setAlert(
                this.closeSession,
                this.continueSession,
                TIMEOUT_HEADER_MSG,
                TIMEOUT_CONTENT_MSG,
                'Logout',
                'Continue',
                this.props
            );
            store.alert.startTimer();
        };

        closeSession = () => {
            store.alert.hideAlert();
            store.alert.clearTimer();

            if (window.offlineApiExtension) {
                store.user.askForPin();
            } else {
                store.user.logout();
            }
        };

        continueSession = () => {
            store.alert.hideAlert();
            store.alert.clearTimer();
            this.BtIdleTimer.reset();
        };

        isPrivate = () => {
            if (window.offlineApiExtension) {
                return store.user.token && store.user.pinValidated;
            } else {
                return store.user.token;
            }
        };

        render() {
            return (
                <div>
                    <Switch>
                    <Route
                        exact
                        path="/"
                        render={() =>
                            this.isPrivate() ? (
                                <Redirect to="/dashboard" />
                            ) : (
                                    <Redirect to="/login" />
                                )
                        }
                    />
                    </Switch>
                    {this.isPrivate() ? (
                        <IdleTimer
                            ref={c => (this.BtIdleTimer = c)}
                            element={document}
                            activeAction={this.onActive}
                            idleAction={this.onIdle}
                            timeout={TIMEOUT}
                            format="MM-DD-YYYY HH:MM:ss.SSS"
                        >
                            <PrivateArea {...this.props} />
                        </IdleTimer>
                    ) : (
                            <PublicArea {...this.props} />
                        )}
                    {/*<DevTools />*/}
                    {store.documents.loadingDocument ? (
                        <div className="document-loader-spinner">
                            <div className="loader-wrapper">
                                <div className="loader loader--style10" title="Loading PDF">
                                    <div className="spinner-10">
                                        <div className="double-bounce1" />
                                        <div className="double-bounce2" />
                                    </div>
                                </div>
                                <h4>Loading document</h4>
                            </div>
                        </div>
                    ) : null}

                    <ModalPopup show={store.alert.show} autoFocus={false} />
                </div>
            );
        }
    },
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js